import Text from "./Text";
import { getLocaleString } from "./Text";
import { withLang } from "./withLang";

let func = getLocaleString;
export { func as getLocaleString, withLang };

export default withLang(Text);
